// extracted by mini-css-extract-plugin
module.exports = {"brand":"_1jaqIW","size":"_3uCNBg","volume":"_2O-zj7","category":"_195QTi","name":"_1OxGy-"};